import { AlertTriangle, XCircle, ShieldOff } from "lucide-react";
import { cn } from "@/lib/utils";
import type { AiValidationResult } from "@/types/ai-validation";

interface ValidationBadgeProps {
  overall: AiValidationResult["overall"];
  className?: string;
}

export function ValidationBadge({ overall, className }: ValidationBadgeProps) {
  if (overall === "WARNING") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border",
          "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
          className,
        )}
      >
        <AlertTriangle className="h-3 w-3" />
        Warning
      </span>
    );
  }

  if (overall === "FAIL") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border",
          "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
          className,
        )}
      >
        <XCircle className="h-3 w-3" />
        Failed
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border",
        "bg-muted text-muted-foreground border-border",
        className,
      )}
    >
      <ShieldOff className="h-3 w-3" />
      Not validated
    </span>
  );
}
